import React, { Suspense } from 'react';
import { connect } from 'react-redux';
import PublicRoute from './PublicRoute';
import ROUTE_CONSTANTS from './RouteConstants';
import { Switch, Router } from '../components/Router';
import HomeLoader from './HomeLoader';
import { getPublicRoutes } from './PublicRoute/routes';
import PropTypes from 'prop-types';
import ProtectedRouteV2 from './ProtectedRouteV2';
import Dashboard from '../containers/Dashboard';
import BlockingLoader from '../../../common/components/BlockingLoader';
import NotFound from '../components/NotFound';

const AppRoutes = props => {
  const publicRoutes = getPublicRoutes();

  return (
    <Router initialEntries={[ROUTE_CONSTANTS.LOGIN]} initialIndex={0} >
      <Suspense fallback={<HomeLoader />}>
        { props.isBlockingLoaderActive && <BlockingLoader /> }
        <Switch>
          {publicRoutes.map(route => (
            <PublicRoute
              key={route.path}
              exact={route.exact}
              path={route.path}
              component={route.component}
              header={route.header}
              isLoggedIn={props.isLoggedIn}
              activeHotelId={props.activeHotelId}
            />
          ))}
          <ProtectedRouteV2
            key={ROUTE_CONSTANTS.DASHBOARD}
            exact={false}
            path={ROUTE_CONSTANTS.DASHBOARD}
            component={Dashboard}
            header={{}}
            isAuthorized={() => true}
            />
          <ProtectedRouteV2 
            header={{}}
            isAuthorized={() => true}
            exact={false}
            component={NotFound}
            path={ROUTE_CONSTANTS.INVALID} />
          <ProtectedRouteV2
            exact={false}
            isAuthorized={() => true}
            component={NotFound}
            path={ROUTE_CONSTANTS.DEFAULT} />
        </Switch>
      </Suspense>
    </Router>
  );
};

AppRoutes.propTypes = {
  isLoggedIn: PropTypes.bool,
  activeHotelId: PropTypes.string
};
const mapStateToProps = state => (
  {
    isLoggedIn: state.app.isLoggedIn,
    userDetails: state.app.userDetails,
    isBlockingLoaderActive: state.app.isBlockingLoaderActive
  });

export default connect(mapStateToProps)(AppRoutes);
